import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { SpinnerService } from 'src/app/services/spinner.service';
import { Subject } from 'rxjs';
import { setConfigTable, validarCodigoExistentesComercial, basicAlert, obtenerFechaSeleccionada, obtenerFechaActual, obtenerHora, timerOut, filtrarCoincidenciaArrayTransportista, openObservacion, openDescripcion, alertaConfirmacion, alertaConfirmacionHTML, openReutilizar, validarInputVacio } from 'src/app/shared/utils';
import { BuscarService } from 'src/app/services/buscar.service';
import { ArticuloService } from 'src/app/services/articulo.service'
import { version } from 'd3';
import { StorageService } from 'src/app/services/storage.service';
import { InterlocutorService } from 'src/app/services/iInterlocutor.service';
import { ModalBusquedaInterlocutorComponent } from 'src/app/shared/modals/busqueda/modal-busqueda-interlocutor/modal-busqueda-interlocutor.component';
import { MdConsultaArticulosComponent } from 'src/app/shared/modals/md-consulta-articulos/md-consulta-articulos.component';
import { ModalBusquedaArticulosComponent } from '../busqueda/modal-busqueda-articulos/modal-busqueda-articulos.component';
import { MaterialEstandarService } from 'src/app/services/materiales-estandar.service'
import { Component, ElementRef, HostListener, OnInit, Input, ViewChild } from '@angular/core';

@Component({
  selector: 'app-modal-materiales-estandar',
  templateUrl: './modal-materiales-estandar.component.html',
  styleUrls: ['./modal-materiales-estandar.component.css']
})
export class ModalMaterialesEstandarComponent implements OnInit {
  @ViewChild('nomcont') nomcont: ElementRef;
  @Input() codArticulo
  codTipoInventario: number = 1;
  clases: any[] = [];
  tiposInventario: any[] = [];
  materiales
  codClase = 1
  public desArticulo: string = '';
  public buscarArticulo: string = 'buscar';
  public disabledArticulo: boolean = false;
  public listipostock: any[] = [];
  public tipostock: string = ""
  public articulos: any[] = [];

  constructor(
    private modalService: NgbActiveModal,
    private spinnerService: SpinnerService,
    private _buscarService: BuscarService,
    private articuloService: ArticuloService,
    private modalService2: NgbActiveModal,
    private interlocutorService: InterlocutorService,
    private modalService3: NgbModal,
    private MaterialEstandarService: MaterialEstandarService,
  ) { }

  ngOnInit(): void {
    this.getTipoInventario();
    this.gettipoinvClase(this.codTipoInventario);
    if(this.codArticulo != null || this.codArticulo != undefined){
      this.onKeyEnterCodArticulo();
    }
  }
  onKeyEnterTipoDocumento(e) {
    if (this.codTipoInventario != null) {
      setTimeout(() => {
        // this.FuncionesTSI.validacionBusquedaPorCodigoInput(this.codSucursal.toString(), '#cboSucursal option:selected', 'El código de sucursal no existe', 'warning', '#codSucursal', '#codInterlocutor');
      }, 200);
    }
    let tecla: any;
    tecla = (document.all) ? e.keyCode : e.which;
    return (tecla != 13);
  }
  onBlurTipoDocumento(e) {
    if (this.codTipoInventario != null) {
      if (e.which == 0) {
        //  this.FuncionesTSI.validacionBusquedaPorCodigoInput(this.codSucursal.toString(), '#cboSucursal option:selected', 'El código de sucursal no existe', 'warning', '#codSucursal', '#codInterlocutor');
        if ($('#cboTipoInventario option:selected').text() == '') {
          this.codTipoInventario = null;
        }
      }
    }
  }

  onChangeTipoDocumento($event, tipinv: number) {
    console.log('modifica select motivo')

    this.gettipoinvClase(tipinv);

  }
  private gettipoinvClase(tipinv: number) {
    this.spinnerService.activarLoading(true);
    this.articuloService.get_tipoinventario_clase(tipinv).subscribe((resp: any) => {
      this.clases = resp.body;
      this.spinnerService.activarLoading(false);
    }, err => {
      this.spinnerService.activarLoading(false);
    })
  }
  private getTipoInventario() {

    this._buscarService.tipo_inventario().subscribe((resp: any) => {
      console.log(resp.body);
      this.tiposInventario = resp.body.list;
    }, err => {

    })
  }
  onNexFocus(tipo: string) {
    if (tipo == 'nuevo') {
      timerOut(10).then((value: any) => {
        if (value) { this.nomcont.nativeElement.focus(); }
      })
    }
  }
  cerrar(): void {
    this.modalService2.dismiss('canceling');
  }
  libre: boolean = false;
  foc_interloc() {
    if (this.desArticulo.length > 0 && this.buscarArticulo == 'buscar') {
      this.libre = true;
    }
  }
  foc_interloc2() {
    if (this.codArticulo.length > 0 && this.buscarArticulo == 'buscar') {
      this.libre = true;
    }
  }
  onKeyEnterCodArticulo() {

    let tecla: any;
    this.spinnerService.activarLoading(true);
    this.articuloService.obtener_articulo(this.codTipoInventario, this.codArticulo).subscribe((resp: any) => {
      this.spinnerService.activarLoading(false);
      console.log('el response')
      console.log(resp)
      this.codArticulo = resp.body.codart
      this.desArticulo = resp.body.descri
      this.disabledArticulo = true;
      this.buscarArticulo = 'borrar'
      this.libre = false;
      this.listipostock.forEach(element => {
        if (element.tipo == resp.body.consto) {
          this.tipostock = element.descripcion
        }
      });
    }, err => {
      this.borrarArticulo();
      this.spinnerService.activarLoading(false);
      basicAlert('No se encotró el artículo.', 'warning', 'Aceptar', null, null, null);
    })
    return (tecla != 13);
  }
  borrarArticulo() {
    this.codArticulo = ""
    this.desArticulo = ""
    this.disabledArticulo = false;
    this.buscarArticulo = 'buscar'
    setTimeout(() => {
      $('#codArticulo').focus();
    }, 250);
  }
  onKeyEnterArticulo() {
    this.openModalArticulo();

    let tecla: any;
    return (tecla != 13);
  }
  openModalArticulo() {

    let tipinv: number = this.codTipoInventario;
    let descri: string = this.desArticulo + "%";
    let codart: string = this.codArticulo;
    let limit: number = 1000;
    let offset: number = 0;

    if (codart == undefined || codart == null) {
      codart = "";
    }

    if (this.desArticulo.length > 0) {
      this.spinnerService.activarLoading(true);
      this.articuloService.buscar(tipinv, codart, descri, limit, offset).subscribe((response: any) => {
        console.log(response);
        this.articulos = response.body;
        this.mostrarModalArticulo();
      }, err => {
        console.log(err);
        basicAlert('Artículo no encontrado', 'warning', 'Aceptar', null, null, this.desArticulo);
        this.spinnerService.activarLoading(false);
      });
    } else {
      basicAlert('Para activar la ayuda ingresar mínimo 1 caracter', 'warning', 'Aceptar');
      return;
    }


  }
  mostrarModalArticulo() {
    const referenciaModal = this.modalService3.open(ModalBusquedaArticulosComponent, { scrollable: true, windowClass: 'modal-lista-articulos', backdrop: 'static' });

    console.log(this.articulos)
    referenciaModal.componentInstance.articulos = this.articulos;

    referenciaModal.result.then((data) => {
      console.log(data);
      this.codArticulo = data.codart
      this.desArticulo = data.descri
      this.spinnerService.activarLoading(false);
      this.listipostock.forEach(element => {
        if (element.tipo == data.consto) {
          this.tipostock = element.descripcion
        }
      });
      this.libre = false;
      this.disabledArticulo = true;
      this.buscarArticulo = 'borrar'
      //this.getByIdPrecioArticulo(this.codTipoInventario, data.codart, this.articulo.codAlmacen);
    }, (reason) => {
      console.log(reason);
    });
  }

  ConsultaMatEstandar(){
    this.MaterialEstandarService.buscarMatEstandar(this.codTipoInventario, this.codArticulo, 1, '', '', '', '', '', '', '').subscribe((response: any) => {
      console.log(response);
      this.materiales = response.body.list;
    }, err => {
      console.log(err);
      basicAlert('Materiales no encontrados', 'warning', 'Aceptar', null, null, this.desArticulo);
      this.spinnerService.activarLoading(false);
    });
  }
}
